import React from 'react';

const IcHearth = ({ fill = '#ADADAD' }: { fill?: string }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='41' height='41' viewBox='0 0 41 41' fill='none'>
      <mask
        id='mask0_16775_4491'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='41'
        height='41'
      >
        <path d='M0.5 0.500004H40.5V40.5H0.5V0.500004Z' fill='white' />
      </mask>
      <g mask='url(#mask0_16775_4491)'>
        <path
          d='M20.5 9.36994L19.1851 8.05502C15.554 4.42393 9.66687 4.42393 6.03577 8.05502C2.40468 11.686 2.40468 17.5732 6.03577 21.2042L20.5 35.6685L34.9642 21.2042C38.5953 17.5732 38.5953 11.686 34.9642 8.05502C31.3331 4.42393 25.446 4.42393 21.8149 8.05502L20.5 9.36994Z'
          stroke={fill}
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M28.2344 20.5H39.3281'
          stroke={fill}
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M1.67188 20.5H11.125'
          stroke={fill}
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M11.125 20.5L14.4062 12.6875'
          stroke={fill}
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M20.3437 24.4062L14.4062 12.6875'
          stroke={fill}
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M20.3438 24.4062L25.2656 15.8125'
          stroke={fill}
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M28.2344 20.5L25.2656 15.8125'
          stroke={fill}
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  );
};

export default IcHearth;
